import React, { useState } from 'react';
import './Header.css';

import { Link, useNavigate } from 'react-router-dom';

const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'Products', to: '/products' },
  { label: 'About Us', to: '#' },
  { label: 'Contact', to: '#' },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleContactClick = (e) => {
    e.preventDefault();
    setMenuOpen(false);
    navigate('/', { replace: false });
    setTimeout(() => {
      const el = document.getElementById('contact');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }, 350);
  };

  const handleAboutClick = (e) => {
    e.preventDefault();
    setMenuOpen(false);
    navigate('/', { replace: false });
    setTimeout(() => {
      const el = document.getElementById('who-we-are');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }, 350);
  };


  return (
    <header className="header">
      <div className="logo">
        <img src="/logo.webp" alt="Appstoria Logo" className="logo-image" />
        <div className="logo-text">
          <span className="logo-bold">App</span><span className="logo-accent">storia</span>
        </div>
      </div>
      <nav className="main-nav">
        <ul className="main-nav-list">
          {navLinks.map((link) => (
            <li key={link.label} className="main-nav-link">
              {link.label === 'Contact' ? (
                <a href="/#contact" className="main-nav-link-text" onClick={handleContactClick}>Contact</a>
              ) : link.label === 'About Us' ? (
                <a href="/#who-we-are" className="main-nav-link-text" onClick={handleAboutClick}>About Us</a>
              ) : (
                link.to ? <Link to={link.to} className="main-nav-link-text">{link.label}</Link> : link.label
              )}
            </li>
          ))}

        </ul>
        <button
          className="hamburger"
          aria-label="Open menu"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span className="hamburger-bar" />
          <span className="hamburger-bar" />
          <span className="hamburger-bar" />
        </button>
        {menuOpen && (
          <div className="mobile-menu">
            <ul>
              {navLinks.map((link) => (
                <li key={link.label} onClick={() => setMenuOpen(false)}>
                  {link.label === 'Contact' ? (
                    <a href="/#contact" onClick={handleContactClick}>Contact</a>
                  ) : link.label === 'About Us' ? (
                    <a href="/#who-we-are" onClick={handleAboutClick}>About Us</a>
                  ) : (
                    link.to ? <Link to={link.to}>{link.label}</Link> : link.label
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
